// @flow

import { isPaymentArcus } from './is-payment-arcus';
import { type PendingIncomingPayment } from './types';

export function getSafeSpeiUrl(incomingPayment: PendingIncomingPayment): string {
  const speiUrl = !isPaymentArcus(incomingPayment)? incomingPayment['spei_url'] : incomingPayment['voucher_url'];
  if (!speiUrl)
    throw new Error('Spei: Invalid state - There is no spei_url property for this payment');

  return speiUrl;
}
